import React, { useState } from "react";
import { ExchangeIcon } from "../../../assets/images/svg/ProductLogoCollection";
import "./ComposeLanding.scss";
import { CheckedCircleFilledIcon, CircleIcon, RequestDocumentsLadingIcon, SendMessageIcon } from "../../../assets/images/svg/SideMenuIconCollection";
import { useNavigate } from "react-router";
import { ComposeLandingPageConstants } from "../../../../src/Core/Common/Constants";
import { useDispatch, useSelector } from "react-redux";
import { checkIfPermissionIsAllowed, isDelegatedUser } from "../../../../src/helper/HelperFunctions";
import { ResourceIdLocators } from "../../../../src/helper/ResourceIdLocators";
import { ApplicationState } from "../../../../src/store";
import { PageDisabledTypes } from "../../../../src/Core/ViewModels/User/UserViewModel";
import FeatureDisabled from "../../../../src/components/Common/Navigation/FeatureDisabled";
import { QnAActions } from "../../../../src/reducers/recipientQuestionAnswerReducer";
import { injectPendoScript } from "../../../../src/components/Common/Pendo/Pendo";

declare global {
  interface Window {
      pendo: any;
  }
}

const ComposeLanding = () => {
  const [selectedCard, setSelectedCard] = useState(ComposeLandingPageConstants.MESSAGE);
  const navigate = useNavigate();
  const allowedPermissions = useSelector((state: ApplicationState) => state.rbacState.resourceList);
  const [isAccessAllowed, setIsAccessAllowed] = React.useState(false);
  const userAuth = useSelector((state: ApplicationState) => state.userAuth.user);
  const { isTestCompany } = useSelector((state: ApplicationState) => state.postAuthState);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({ type: QnAActions.SET, payload: [] });
  }, []);

  React.useEffect(() => {
    // Check whether page permission is allowed
    setIsAccessAllowed(checkIfPermissionIsAllowed(allowedPermissions, ResourceIdLocators.DRL.DRLBtnNewRequest)
      || checkIfPermissionIsAllowed(allowedPermissions, ResourceIdLocators.Global.NewMessageBtn)
    );
  }, [allowedPermissions]);
  const handleCardClick = (card: string) => {
    setSelectedCard(card);
  };

  React.useEffect(()=>{
    if(userAuth?.profile){
        injectPendoScript(userAuth,isTestCompany);
        }
},[userAuth?.profile]);

  const handleSubmitButtonClick = () => {
    if (selectedCard === ComposeLandingPageConstants.MESSAGE) {
      navigate("/compose-message");
    } else {
      navigate("/compose-dr");
    }
  };

  return (
    isAccessAllowed ? <div className="compose-landing-page-container">
      <div className="brand-logo-container">
        <ExchangeIcon />
      </div>


      <div className="landing-cards-container">
        <div className={"cards-div"} onClick={() => { handleCardClick(ComposeLandingPageConstants.MESSAGE); }}>
          {selectedCard === ComposeLandingPageConstants.MESSAGE ? <CheckedCircleFilledIcon width={16} height={16} /> : <CircleIcon width={16} height={16} />}
          <SendMessageIcon color={selectedCard === ComposeLandingPageConstants.MESSAGE ? "#0973BA" : "#C4C6C8"} />
          <div className={`cards-description ${selectedCard === ComposeLandingPageConstants.MESSAGE ? "checked-card" : "unchecked-card"}`}>
            <span>{ComposeLandingPageConstants.MESSAGE_CARD_TITLE}</span>
            <br />
            <span>{ComposeLandingPageConstants.MESSAGE_CARD_DESCRIPTION}</span>
          </div>
        </div>
        {!isDelegatedUser() && <div className={"cards-div"} onClick={() => { handleCardClick(ComposeLandingPageConstants.DR); }}>
          {selectedCard === ComposeLandingPageConstants.DR ? <CheckedCircleFilledIcon width={16} height={16} /> : <CircleIcon width={16} height={16} />}
          <RequestDocumentsLadingIcon color={selectedCard === ComposeLandingPageConstants.DR ? "#0973BA" : "#C4C6C8"} />
          <div className={`cards-description ${selectedCard === ComposeLandingPageConstants.DR ? "checked-card" : "unchecked-card"}`}>
            <span>{ComposeLandingPageConstants.DR_CARD_TITLE}</span>
            <br />
            <span>{ComposeLandingPageConstants.DR_CARD_DESCRIPTION}</span>
          </div>
        </div>}
      </div>

      <button
        className="button-primary-blue-2 continue-button-dr"
        onClick={handleSubmitButtonClick}
      >
        {ComposeLandingPageConstants.CONTINUE}
      </button>
    </div> : <FeatureDisabled type={PageDisabledTypes.PageAccessDenied} />
  );
};

export default ComposeLanding;